export default {
  main: '#006937',
  secondary: '#960048',
  contrastingColor: '#ffffff',
  priceColor: '#006937',
  entryBackground: '#ffffff',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#ffffff',
};
